export default __webpack_public_path__ + "static/media/TRAIN TAB.61620e68.svg";